export const getTags = store => store.tags.data;
